var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.user)?_c('div',{attrs:{"id":"firebaseui-auth-container"}}):_c('div',[_c('div',[_vm._v("Email: "+_vm._s(_vm.user.email))]),_c('span',{staticClass:"btn btn-primary",on:{"click":_vm.signout}},[_vm._v("Signout")])])}
var staticRenderFns = []

export { render, staticRenderFns }